import { createRouter, createWebHistory } from "vue-router";
import local_storage_service from "@/services/utilities/local-storage";
import store from "@/store/store";
import toast from "@/services/toast";
import user_orders from "@/services/user/order";
import auth from "@/services/auth";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior() {
    return {
      left: 0,
      top: 0
    };
  },
  routes: [
    // for guests
    {
      path: "",
      meta: {
        guest: true
      },
      component: () => import("@/layouts/full-page"),
      children: [
        // {
        //   path: "/",
        //   name: "Splash",
        //   component: () => import("@/views/auth/splash.vue")
        // },
        {
          path: "/eligibility-check",
          name: "EligibilityCheck",
          component: () => import("@/views/auth/eligibility-check.vue")
        },
        {
          path: "",
          name: "Login",
          component: () => import("@/views/auth/login.vue")
        },
        {
          path: "/register",
          name: "Register",
          component: () => import("@/views/auth/register.vue")
        },
        {
          path: "/new-password",
          name: "NewPassword",
          component: () => import("@/views/auth/new-password.vue")
        },
        {
          path: "/forgot-password",
          name: "ForgotPassword",
          component: () => import("@/views/auth/forgot-password.vue")
        },
        {
          path: "/reset-password",
          name: "ResetPassword",
          component: () => import("@/views/auth/reset-password.vue")
        }
      ]
    },
    // for guests and logged in users
    {
      path: "",
      component: () => import("@/layouts/full-page"),
      children: [
        {
          path: "/verification",
          name: "Verification",
          component: () => import("@/views/auth/verification.vue")
        },
        {
          path: "/program",
          name: "Program",
          component: () => import("@/views/auth/program-code.vue")
        }
      ]
    },
    // if not completed first order
    {
      path: "",
      meta: {
        requiresAuth: true,
        allowed_if_not_completed_first_order: true
      },
      component: () => import("@/layouts/full-page"),
      children: [
        {
          path: "/quiz",
          name: "Quiz",
          component: () => import("@/views/auth/quiz.vue"),
          beforeEnter: async (to, from, next) => {
            //Check if incomplete order is already there or not
            let checkOrderResponse;
            let input = "order_complete_pending";
            checkOrderResponse = await user_orders.checkOrder(input);
            if (checkOrderResponse.data.status == "200" && checkOrderResponse.data.message == 'allow') {
              return next();
            } else {
              toast.error(checkOrderResponse.data.message);
              return next({
                name: "Orders"
              });
            }
          }
        },
        {
          path: "/place-order",
          name: "PlaceOrder",
          component: () => import("@/views/auth/place-order.vue"),
          beforeEnter: async (to, from, next) => {
            //Check if incomplete order is already there or not
            let checkOrderResponse;
            let input = "order_complete_pending";
            checkOrderResponse = await user_orders.checkOrder(input);
            if (checkOrderResponse.data.status == "200" && checkOrderResponse.data.message == 'allow') {
              return next();
            } else {
              toast.error(checkOrderResponse.data.message);
              return next({
                name: "Orders"
              });
            }
          }
        }
      ]
    },
    // for both admin and users (Main layout)
    {
      path: "",
      meta: {
        requiresAuth: true
      },
      component: () => import("@/layouts/main/Main.vue"),
      children: [
        {
          path: "/coming-soon",
          name: "ComingSoon",
          component: () => import("@/views/coming-soon.vue")
        },
        {
          path: "orders",
          name: "Orders",
          component: () => import("@/views/user/order/list")
        },
        {
          path: "result/:order_id",
          name: "Results",
          component: () => import("@/views/user/order/result")
        },
        {
          path: "message-center",
          name: "MessageCenter",
          component: () => import("@/views/user/messages/list")
        },
        {
          path: "orders/edit/:order_id",
          name: "EditOrder",
          component: () => import("@/views/user/order/edit")
        },
        {
          path: "user/update-profile",
          name: "UpdateProfile",
          component: () => import("@/views/user/update-profile")
        },
        // Update Profile
        {
          path: "change-password",
          name: "ChangePassword",
          component: () => import("@/views/change-password")
        }
      ]
    },
    // for admin only
    {
      path: "",
      component: () => import("@/layouts/main/Main.vue"),
      meta: {
        requiresAuth: true,
        is_admin: true
      },
      children: [
        {
          path: "/dashboard",
          name: "Dashboard",
          component: () => import("@/views/dashboard.vue")
        },
        //Upload Test Result file
        {
          path: "/upload-test-results",
          name: "UploadTestResults",
          component: () => import("@/views/admin/upload-test-results.vue")
        },
        //Verify Test Results
        {
          path: "/verify-test-results",
          name: "VerifyTestResults",
          component: () => import("@/views/admin/verify-test-results.vue")
        },
        //Reports
        {
          path: "/reports",
          name: "Reports",
          component: () => import("@/views/admin/reports.vue")
        },
        // New graph-based reports
        {
          path: "/monthly-reports",
          name: "MonthlyReports",
          component: () => import("@/views/admin/reports/MonthlyReports.vue")
        },
        //Participant Report
        {
          path: "/participant-report",
          name: "participantReport",
          component: () => import("@/views/admin/reports/participants.vue")
        },
        //Client Navigation Report
        {
          path: "/client-navigation",
          name: "clientNavigation",
          component: () => import("@/views/admin/reports/clientNavigation.vue")
        },
        //BCHD Negative Tests Report
        {
          path: "/negative-tests",
          name: "BCHDNegativeTests",
          component: () => import("@/views/admin/reports/BCHDNegativeTests.vue")
        },
         //BCHD positive Tests Report
        {
          path: "/bchd-tests-report",
          name: "BCHDTestsReport",
          component: () => import("@/views/admin/reports/BCHDTestsReport.vue")
        },
        // Alaska / Oklahoma / Kansas Reportt
        {
          path: "/state-report",
          name: "StateReport",
          component: () => import("@/views/admin/reports/StateReport.vue")
        },
         //reach Report
        {
          path: "/program-code-report",
          name: "programCodeReport",
          component: () => import("@/views/admin/reports/ProgramCodeReport.vue")
        },
        // Risk Assessment Report
        {
          path: "risk-assessment-report",
          name: "RiskAssessmentReport",
          component: () => import("@/views/admin/risk-assessment/list")
        },
        // Risk Assessment
        {
          path: "risk-assessment",
          name: "RiskAssessment",
          component: () => import("@/views/admin/risk-assessment/list")
        },
        {
          path: "risk-assessment/:risk_assessment_id",
          name: "ViewRiskManagement",
          component: () => import("@/views/admin/risk-assessment/view")
        },
        // Participants
        {
          path: "participants",
          name: "Participants",
          component: () => import("@/views/participant/list")
        },
        {
          path: "participants/add",
          name: "AddParticipant",
          component: () => import("../views/participant/add")
        },
        {
          path: "participants/edit/:user_id",
          name: "EditParticipant",
          component: () => import("@/views/participant/edit")
        },
        {
          path: "/settings",
          name: "Settings",
          component: () => import("@/views/master/settings")
        },
        //Master > State
        {
          path: "master/state",
          name: "States",
          component: () => import("@/views/master/state/state-list")
        },
        // Master > Race
        {
          path: "master/races",
          name: "Races",
          component: () => import("@/views/master/race/list")
        },
        {
          path: "master/race/add",
          name: "AddRace",
          component: () => import("@/views/master/race/add")
        },
        {
          path: "master/race/edit/:id",
          name: "EditRace",
          component: () => import("@/views/master/race/edit")
        },
        // Master > Gender Identity
        {
          path: "master/gender-identities",
          name: "GenderIdentities",
          component: () => import("@/views/master/gender-identity/list")
        },
        {
          path: "master/gender-identity/add",
          name: "AddGenderIdentity",
          component: () => import("@/views/master/gender-identity/add")
        },
        {
          path: "master/gender-identity/edit/:id",
          name: "EditGenderIdentity",
          component: () => import("@/views/master/gender-identity/edit")
        },
        // Master > Sex With
        {
          path: "master/sex-with",
          name: "SexWith",
          component: () => import("@/views/master/sex-with/list")
        },
        {
          path: "master/sex-with/add",
          name: "AddSexWith",
          component: () => import("@/views/master/sex-with/add")
        },
        {
          path: "master/sex-with/edit/:id",
          name: "EditSexWith",
          component: () => import("@/views/master/sex-with/edit")
        },
        // Master > Sex at birth
        {
          path: "master/sex-at-birth",
          name: "SexAtBirth",
          component: () => import("@/views/master/sex-at-birth/list")
        },
        {
          path: "master/sex-at-birth/add",
          name: "AddSexAtBirth",
          component: () => import("@/views/master/sex-at-birth/add")
        },
        {
          path: "master/sex-at-birth/edit/:id",
          name: "EditSexAtBirth",
          component: () => import("@/views/master/sex-at-birth/edit")
        },
        // Master > navajo zipcode
        {
          path: "master/navajo-zipcode",
          name: "NavajoZipCode",
          component: () => import("@/views/master/navajo-zip-code/list")
        },
        {
          path: "master/navajo-zipcode/add",
          name: "AddNavajoZipCode",
          component: () => import("@/views/master/navajo-zip-code/add")
        },
        {
          path: "master/navajo-zipcode/edit/:id",
          name: "EditNavajoZipCode",
          component: () => import("@/views/master/navajo-zip-code/edit")
        },
        // Master > Disease
        {
          path: "master/diseases",
          name: "Diseases",
          component: () => import("@/views/master/disease/list")
        },
        {
          path: "master/disease/add",
          name: "AddDisease",
          component: () => import("@/views/master/disease/add")
        },
        {
          path: "master/disease/edit/:id",
          name: "EditDisease",
          component: () => import("@/views/master/disease/edit")
        },
        // Master > How-Heard
        {
          path: "master/how-heard",
          name: "HowHeard",
          component: () => import("@/views/master/how-heard/list")
        },
        {
          path: "master/how-heard/add",
          name: "AddHowHeard",
          component: () => import("@/views/master/how-heard/add")
        },
        {
          path: "master/how-heard/edit/:id",
          name: "EditHowHeard",
          component: () => import("@/views/master/how-heard/edit")
        },
        // Master > Test-Order
        {
          path: "master/upload-test-order",
          name: "UploadTestOrder",
          component: () => import("@/views/master/upload-test-order/uploadTestOrder")
        },
        // Master > Specimen Type
        // {
        //   path: "master/specimen-types",
        //   name: "SpecimenTypes",
        //   component: () => import("@/views/master/specimen-type/list")
        // },
        // {
        //   path: "master/specimen-type/add",
        //   name: "AddSpecimenType",
        //   component: () => import("@/views/master/specimen-type/add")
        // },
        // {
        //   path: "master/specimen-type/edit/:id",
        //   name: "EditSpecimenType",
        //   component: () => import("@/views/master/specimen-type/edit")
        // },
        // Master > Clinic
        {
          path: "master/clinic",
          name: "Clinic",
          component: () => import("@/views/master/clinic/list")
        },
        {
          path: "master/clinic/add",
          name: "AddClinic",
          component: () => import("@/views/master/clinic/add")
        },
        {
          path: "master/clinic/edit/:id",
          name: "EditClinic",
          component: () => import("@/views/master/clinic/edit")
        },
        // Permission Module
        {
          path: "permission",
          name: "Permission",
          component: () => import("@/views/admin/permission/list")
        },
        {
          path: "permission/add",
          name: "AddPermission",
          component: () => import("@/views/admin/permission/add")
        },
        {
          path: "permission/edit/:permission_id",
          name: "EditPermission",
          component: () => import("@/views/admin/permission/edit")
        },
        // Master > ExternalAdmin
        {
          path: "external-admin",
          name: "ExternalAdmin",
          component: () => import("@/views/admin/external-admin/list")
        },
        {
          path: "external-admin/add",
          name: "AddExternalAdmin",
          component: () => import("@/views/admin/external-admin/add")
        },
        {
          path: "external-admin/edit/:id",
          name: "EditExternalAdmin",
          component: () => import("@/views/admin/external-admin/edit")
        },
        // Sponsor User Management
        {
          path: "sponsor",
          name: "SponsorUserList",
          component: () => import("@/views/admin/sponsor/list")
        },
        {
          path: "sponsor/add",
          name: "AddSponsorUser",
          component: () => import("@/views/admin/sponsor/add")
        },
        {
          path: "sponsor/edit/:id",
          name: "EditSponsorUser",
          component: () => import("@/views/admin/sponsor/edit")
        },
        // Role Module
        {
          path: "role",
          name: "Role",
          component: () => import("@/views/admin/role/list")
        },
        {
          path: "role/add",
          name: "AddRole",
          component: () => import("@/views/admin/role/add")
        },
        {
          path: "role/edit/:id",
          name: "EditRole",
          component: () => import("@/views/admin/role/edit")
        },
        //
        {
          path: "announcement/",
          name: "Announcement",
          component: () => import("@/views/master/announcement/addEdit")
        },
        //Label Report
        {
          path: "label-report",
          name: "LabelReport",
          component: () => import("@/views/admin/label-report")
        },
        // Admin Module
        {
          path: "admins",
          name: "User",
          component: () => import("@/views/admin/user/list")
        },
        {
          path: "admin/add",
          name: "AddUser",
          component: () => import("@/views/admin/user/add")
        },
        {
          path: "admin/edit/:id",
          name: "EditUser",
          component: () => import("@/views/admin/user/edit")
        },
        // Test Type Module
        {
          path: "master/specimen-types",
          name: "TestTypes",
          component: () => import("@/views/master/test-type/list")
        },
        {
          path: "master/specimen-types/add",
          name: "AddTestType",
          component: () => import("@/views/master/test-type/add")
        },
        {
          path: "master/specimen-types/edit/:id",
          name: "EditTestType",
          component: () => import("@/views/master/test-type/edit")
        },
        {
          path: "master/specimen-types/region-lock/:id/:name",
          name: "RegionLock",
          component: () => import("@/views/master/test-type/region-lock")
        },
        // Test Kit Module
        {
          path: "master/test-kit",
          name: "TestKits",
          component: () => import("@/views/master/test-kit/list")
        },
        {
          path: "master/test-kit/add",
          name: "AddTestKit",
          component: () => import("@/views/master/test-kit/add")
        },
        {
          path: "master/test-kit/edit/:id",
          name: "EditTestKit",
          component: () => import("@/views/master/test-kit/edit")
        },
        // Assay Type Module
        // Test Kit Module
        {
          path: "master/assay-type",
          name: "AssayTypes",
          component: () => import("@/views/master/assay-type/list")
        },
        {
          path: "master/assay-type/add",
          name: "AddAssayType",
          component: () => import("@/views/master/assay-type/add")
        },
        {
          path: "master/assay-type/edit/:id",
          name: "EditAssayType",
          component: () => import("@/views/master/assay-type/edit")
        },
        // Symptom Module
        {
          path: "master/symptom",
          name: "Symptoms",
          component: () => import("@/views/master/symptom/list")
        },
        {
          path: "master/symptom/add",
          name: "AddSymptom",
          component: () => import("@/views/master/symptom/add")
        },
        {
          path: "master/symptom/edit/:id",
          name: "EditSymptom",
          component: () => import("@/views/master/symptom/edit")
        },
        // Reminder Queue Module
        {
          path: "master/reminder-queue",
          name: "ReminderQueues",
          component: () => import("@/views/master/reminder-queue/list")
        },
        {
          path: "master/order-symptoms",
          name: "OrderSymptoms",
          component: () => import("@/views/master/order-symptoms/list")
        },
        {
          path: "master/navajo-nation",
          name: "NavajoNation",
          component: () => import("@/views/admin/reports/NavajoNationReport")
        },
        {
          path: "order-results",
          name: "OrderResults",
          component: () => import("@/views/admin/reports/OrderResultsReport")
        },
        {
          path: "order-samples",
          name: "OrderSamples",
          component: () => import("@/views/admin/reports/OrderSamplesReport")
        },
        {
          path: "master/southern-tribal-health",
          name: "SouthernTribalHealthBoard",
          component: () => import("@/views/admin/reports/SouthernTribalHealthBoard")
        },
        //Program Code Module
        {
          path: "master/program-code",
          name: "ProgramCodes",
          component: () => import("@/views/master/program-code/list")
        },
        {
          path: "master/program-code/add",
          name: "AddProgramCode",
          component: () => import("@/views/master/program-code/add")
        },
        {
          path: "master/program-code/edit/:id",
          name: "EditProgramCode",
          component: () => import("@/views/master/program-code/edit")
        },
        //Order Results
        {
          path: "master/order-result",
          name: "OrderResult",
          component: () => import("@/views/master/order-result/list")
        },
        {
          path: "master/order-result/add",
          name: "AddOrderResult",
          component: () => import("@/views/master/order-result/add")
        },
        {
          path: "master/order-result/edit/:id",
          name: "EditOrderResult",
          component: () => import("@/views/master/order-result/edit")
        },
        {
          path: "/line-item-data",
          name: "LineItemData",
          component: () => import("@/views/admin/reports/LineItemData.vue")
        },
        {
          path: "/positive-report",
          name: "PositiveReport",
          component: () => import("@/views/admin/reports/PositiveReport.vue")
        },
        // Master > Region
        {
          path: "master/region",
          name: "RegionList",
          component: () => import("@/views/master/region/list")
        },
        {
          path: "master/region/add",
          name: "AddRegion",
          component: () => import("@/views/master/region/add")
        },
        {
          path: "master/region/edit/:id",
          name: "EditRegion",
          component: () => import("@/views/master/region/edit")
        },
      ]
    },
    {
      path: "",
      component: () => import("@/layouts/full-page"),
      children: [
        {
          path: "/404",
          name: "404",
          component: () => import("@/views/404.vue")
        },
        {
          path: "/:pathMatch(.*)*",
          name: "NotFound",
          component: () => import("@/views/404.vue")
        }
      ]
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  if ("lang" in to.query) {
    if (to.query.lang == "es" || to.query.lang == "en") {
      store.dispatch(
        "updateLanguagePreference",
        to.query.lang
      );
      if (local_storage_service.isAuthenticated()) {
        let inputs = {
          id: store.state.user_info.id,
          lang: to.query.lang
        }
        auth.updateLang(inputs);
      }

    }
  }
  if("language_preference" in store.state){
    if (local_storage_service.isAuthenticated()) {
      let inputs = {
        id: store.state.user_info.id,
        lang: store.state.language_preference
      }
      auth.updateLang(inputs);
      store.dispatch(
        "updateLanguagePreference",
        store.state.language_preference
      );
    }
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!local_storage_service.isAuthenticated()) {
      next({
        name: "Login",
        params: {
          nextUrl: to.fullPath
        }
      });
      return;
    } else {
      if (
        store.getters.isUserType("user") &&
        !store.state.user_info.is_first_order_completed &&
        !to.matched.some(
          record => record.meta.allowed_if_not_completed_first_order
        )
      ) {
        // if user has not completed first order
        // redirect them to quiz
        store.state.language_preference == 'es' ?
          toast.info("Complete su primer pedido"):
          toast.info("Complete your first order.");
        next({
          name: "Quiz"
        });
        return;
      }

      if (
        store.state.user_info.type === "user" &&
        to.matched.some(record => record.meta.is_admin)
      ) {
        // if user is trying to access admin pages
        // redirect to 404 page
        next({
          name: "404"
        });
        return;
      }
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (!local_storage_service.isAuthenticated()) {
      next();
      return;
    } else {
      if (store.state.user_info.type === "user" || store.state.user_info.type === "externaladmin") {
        next({
          name: "Orders"
        });
        return;
      } else {
        next({
          name: "Dashboard"
        });
        return;
      }
    }
  }

  next();
});

export default router;
